module.exports = __webpack_public_path__ + "static/media/roundProfileMe.ae70d417.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/AboutPage/roundProfileMe.png
// module id = 272
// module chunks = 0